import React from 'react';
import { SuiContainer, SuiLabel } from '@splashthat/sui';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';

import BackgroundImageTools from '../../../tools/BackgroundImageTools';

const BASE_CLASS_NAME = 'BlockTools';

export default function BlockTools() {
    const { theme } = useTouchpointData();

    return (
        <SuiContainer>
            <SuiLabel>Background</SuiLabel>
            <BackgroundImageTools colors={theme.colors} qaId={BASE_CLASS_NAME} />
        </SuiContainer>
    );
}
